import React, { useState } from 'react'

export default function LineUpAway() {
    const [Homerenk , Homesetrenk] = useState("#a41d34")
    const [Homerenk2 , Homesetrenk2] = useState("#14c0f1")
    const [Awayrenk , Awasetrenk] = useState("#163962")
    const [Awarenk2 , Awasetrenk2] = useState("#ffed00")
    const [lineStyle , setlineStyle] = useState("4-3-3")
  return (
    <div className='TeamsLineUpAway'>

    <div style={{gridTemplateColumns:"repeat(1, 1fr)"}} className='wrapperjersey'>
    <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Awayrenk} `}} className="football-kit__shirt-teamsPage">23</div>
      <div style={{ background: 	` ${Awayrenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Awayrenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Batshuayi</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Awayrenk} `}} className="football-kit__shirt-teamsPage">13</div>
      <div style={{ background: 	` ${Awayrenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Awayrenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>E. Valencia</div>
   </div>

    </div>
    <div style={{gridTemplateColumns:"repeat(1, 1fr)"}} className='wrapperjersey'>
    <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Awayrenk} `}} className="football-kit__shirt-teamsPage">8</div>
      <div style={{ background: 	` ${Awayrenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Awayrenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Mert Hakan</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Awayrenk} `}} className="football-kit__shirt-teamsPage">27</div>
      <div style={{ background: 	` ${Awayrenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Awayrenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Crespo</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Awayrenk} `}} className="football-kit__shirt-teamsPage">5</div>
      <div style={{ background: 	` ${Awayrenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Awayrenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>W. Areo</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Awayrenk} `}} className="football-kit__shirt-teamsPage">99</div>
      <div style={{ background: 	` ${Awayrenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Awayrenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Emre Mor</div>
   </div>
   
    </div>
 
    <div style={{gridTemplateColumns:"repeat(1, 1fr)"}} className='wrapperjersey'>
    <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Awayrenk} `}} className="football-kit__shirt-teamsPage">7</div>
      <div style={{ background: 	` ${Awayrenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Awayrenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Ferdi K.</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Awayrenk} `}} className="football-kit__shirt-teamsPage">3</div>
      <div style={{ background: 	` ${Awayrenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Awayrenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>S. Akaydin</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Awayrenk} `}} className="football-kit__shirt-teamsPage">41</div>
      <div style={{ background: 	` ${Awayrenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Awayrenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Szalai</div>
   </div>
   <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Awayrenk} `}} className="football-kit__shirt-teamsPage">6</div>
      <div style={{ background: 	` ${Awayrenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Awayrenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Alioski</div>
   </div>
    </div>
    <div style={{gridTemplateColumns:"repeat(1, 1fr)"}} className='wrapperjersey'>
    <div className="container__inner">
   <div className="football-kit-teamsPage football-kit--stripes">
      <div style={{background: ` ${Awayrenk} `}} className="football-kit__shirt-teamsPage">1</div>
      <div style={{ background: 	` ${Awayrenk} `}} className="football-kit__stripes-teamsPage  football-kit__stripes--left"></div>
      <div style={{background: ` ${Awayrenk} ` }} className="football-kit__stripes-teamsPage  football-kit__stripes--right"></div>
   </div>
   <div className='TeamsPageTeamPlayerName'>Altay</div>
   </div>
    </div>
</div>
  )
}
